export const GENDER_OPTIONS = ['Feminino', 'Masculino', 'Não-binário', 'Prefiro não informar'];

export const CIVIL_STATE_OPTIONS = ['Solteiro(a)', 'Casado(a)', 'Divorciado(a)', 'Viúvo(a)', 'União Estável'];

// Must match the psp_education_level enum.
export const EDUCATION_LEVEL_OPTIONS = [
    'Ensino Fundamental',
    'Ensino Médio',
    'Ensino Técnico',
    'Graduação',
    'Pós-Graduação',
    'Mestrado',
    'Doutorado',
    'Pós-Doutorado'
];

export const UF_OPTIONS = [
    'AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI',
    'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SP', 'SE', 'TO'
];

export const DEFAULT_NATIONALITY = 'Brasileiro(a)';

export const TERMS_VERSION = '1.0';

// The terms of use text is supplied manually by the responsible. Leave empty to show the placeholder.
export const TERMS_OF_USE_TEXT = '';

export const PASSWORD_RULES = [
    { key: 'length', label: 'Mínimo de 8 caracteres', test: (v) => v.length >= 8 },
    { key: 'upper', label: 'Uma letra maiúscula', test: (v) => /[A-Z]/.test(v) },
    { key: 'lower', label: 'Uma letra minúscula', test: (v) => /[a-z]/.test(v) },
    { key: 'digit', label: 'Um número', test: (v) => /\d/.test(v) },
    { key: 'special', label: 'Um caractere especial', test: (v) => /[^A-Za-z0-9]/.test(v) }
];

export const isStrongPassword = (value) => PASSWORD_RULES.every((rule) => rule.test(String(value || '')));
